import { KpiGoal } from "../types/kpiGoals";

/**
 * Hardcoded goals configuration.
 * FUTURE: Replace with API call (e.g., getKpiGoals(year, month?))
 */
export const KPI_GOALS: KpiGoal[] = [
  {
    id: "yearly-transaction-amount-2026",
    label: "2026 Transaction Goal",
    description: "Total transaction amount target for 2026",
    metricKey: "totalTransactionAmount",
    scope: "yearly",
    year: 2026,
    targetValue: 3_000_000_000, // 30M DKK in øre
    valueType: "currency",
    color: "#503595",
  },
  {
    id: "monthly-transaction-amount-2026",
    label: "Monthly Transaction Goal",
    description: "Transaction amount target for current month",
    metricKey: "totalTransactionAmount",
    scope: "monthly",
    year: 2026,
    targetValue: 300_000_000, // 3M DKK in øre
    valueType: "currency",
    color: "rgb(99, 102, 241)",
  },
  {
    id: "monthly-unique-purchasing-users-2026",
    label: "Unique Purchasing Users",
    description: "Unique purchasing users target for current month",
    metricKey: "uniquePurchasingUsers",
    scope: "monthly",
    year: 2026,
    targetValue: 3_000,
    valueType: "integer",
    color: "rgb(34, 197, 94)",
  },
];
